import { Button } from '@wome/ui'

import s from './styles.module.scss'

import { useAuth } from '@/providers/auth/useAuth'
import { useHouse } from '@/providers/useHouse'

const Custom404 = () => {
  const { runLogout } = useAuth()
  const { setHouse } = useHouse()

  return (
    <main className={s.root}>
      <h1 className={s.title}>
        Oh, non ! Cette page <br /> n&apos;existe pas.
      </h1>
      <Button
        onClick={() => {
          runLogout()
          setHouse(undefined)
        }}
      >
        Retour
      </Button>
    </main>
  )
}

export default Custom404
